import React from 'react'
import styles from './styles.module.css'

export const ExampleComponent = ({ text }) => {
  return <div className={styles.test}>Example Component: {text}</div>
}


export class ExampleWebComponent extends HTMLElement{

  defaultAction(e){
    console.warn("Did you forget to provide callback URL");
    console.warn(e);
  }
 
   setcallbackUrl(callbackUrl) {
     this.callbackUrl = callbackUrl ?? this.defaultAction;
   }
 
   connectedCallback() {
     this.mountPoint = document.createElement('span');
     const shadowRoot = this.attachShadow({ mode: 'open' });
     shadowRoot.appendChild(this.mountPoint);
     const name = this.getAttribute('text');
     const callbackUrl = this.getAttribute('callbackUrl');
     // Bind event
     this.act = (e) => { 
     this.dispatchEvent(new CustomEvent(callbackUrl,{bubbles: true,detail:{ age: e}}))};
 
     this.setcallbackUrl(this.act);
 
     ReactDOM.render(this.createFormSubmitter(name,this.callbackUrl), this.mountPoint);
     retargetEvents(shadowRoot);
   }
 
   createFormSubmitter(name,callbackUrl) {
     let formsubmitter =  React.createElement(ExampleComponent, { name, callbackUrl }, React.createElement('slot'));
     return formsubmitter;
   }
 
   static get observedAttributes() {
     return ['text'];
   }
 
   attributeChangedCallback(name, oldValue, newValue) {
     if (name === 'text') {
       ReactDOM.render(this.createFormSubmitter(newValue), this.mountPoint);
     }
   }
 }

customElements.define('dunnhumby-example',ExampleWebComponent);
